require('./vendor/bootstrap');
require('./vendor/jquery.fitvids');

require('./source/ajax');
require('./source/app');